import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Keep the real stack in devtools instead of showing only React's generic overlay.
    console.error('Health Buddy runtime error', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] grid place-items-center px-4 py-12">
        <div className="max-w-lg rounded-2xl border border-[#FAD2D2] bg-[#FFF5F5] p-6 text-center">
          <AlertTriangle className="h-8 w-8 text-[#D9534F] mx-auto" />
          <h1 className="font-display text-3xl text-[#1A1A1A] mt-4">Something went wrong</h1>
          <p className="text-sm text-[#5A5A5A] mt-2">
            Please refresh once. If it repeats, open the browser console and share the first Health Buddy runtime error.
          </p>
          <pre className="mt-4 max-h-32 overflow-auto rounded-xl bg-white p-3 text-left text-xs text-[#B00020] whitespace-pre-wrap">
            {this.state.error?.message || 'Unknown runtime error'}
          </pre>
          <Button
            onClick={() => {
              localStorage.removeItem('hb_lang');
              window.location.reload();
            }}
            className="mt-5 rounded-full bg-[#1E3F33] hover:bg-[#2A5244] text-white"
          >
            Refresh app
          </Button>
        </div>
      </div>
    );
  }
}
